/* ===== AY-49 Video-Making Kit — Scripts ===== */

document.addEventListener('DOMContentLoaded', function() {

  // ===== Fade-in on scroll =====
  var fadeElements = document.querySelectorAll('.fade-in');
  if (fadeElements.length > 0) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    fadeElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  // ===== Smooth scroll for anchor links =====
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        var target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  // ===== Sticky CTA show/hide =====
  var stickyCta = document.getElementById('stickyCta');
  if (stickyCta) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 500) {
        stickyCta.style.display = 'flex';
      } else {
        stickyCta.style.display = 'none';
      }
    }, { passive: true });
  }

  // ===== WhatsApp Form Sender =====
  var btnSend = document.getElementById('btnSendWhatsapp');
  if (btnSend) {
    btnSend.addEventListener('click', function() {
      var name = document.getElementById('w-name');
      var phone = document.getElementById('w-phone');
      var city = document.getElementById('w-city');
      var address = document.getElementById('w-address');
      var quantity = document.getElementById('w-quantity');
      var notes = document.getElementById('w-notes');

      // Validation
      if (!name || !name.value.trim()) {
        alert('⚠️ عافاك عمر الاسم الكامل');
        name.focus();
        return;
      }
      if (!phone || !phone.value.trim()) {
        alert('⚠️ عافاك عمر رقم الهاتف');
        phone.focus();
        return;
      }
      if (!city || !city.value.trim()) {
        alert('⚠️ عافاك عمر المدينة');
        city.focus();
        return;
      }
      if (!address || !address.value.trim()) {
        alert('⚠️ عافاك عمر العنوان');
        address.focus();
        return;
      }
      if (!quantity || !quantity.value) {
        alert('⚠️ عافاك اختار الكمية');
        quantity.focus();
        return;
      }

      // Build price from quantity
      var qty = quantity.value;
      var price = '';
      if (qty === '1') price = '199 DH';
      else if (qty === '2') price = '350 DH';
      else if (qty === '3') price = '499 DH';

      // Build WhatsApp message
      var msg = '*سلام، عندي طلب جديد!* %0A%0A';
      msg += '👤 *الاسم:* ' + encodeURIComponent(name.value.trim()) + '%0A';
      msg += '📞 *الهاتف:* ' + encodeURIComponent(phone.value.trim()) + '%0A';
      msg += '🏙️ *المدينة:* ' + encodeURIComponent(city.value.trim()) + '%0A';
      msg += '📍 *العنوان:* ' + encodeURIComponent(address.value.trim()) + '%0A';
      msg += '📦 *الكمية:* ' + qty + ' كيت' + '%0A';
      msg += '💰 *الثمن:* ' + price + '%0A';

      if (notes && notes.value.trim()) {
        msg += '💬 *ملاحظات:* ' + encodeURIComponent(notes.value.trim()) + '%0A';
      }

      msg += '%0A📱 *AY-49 Video-Making Kit*';

      // Open WhatsApp
      var waUrl = 'https://wa.me/212660519181?text=' + msg;
      window.open(waUrl, '_blank');

      // Show success feedback
      btnSend.innerHTML = '✅ جاري التوجيه لواتساب...';
      btnSend.style.background = '#0d635c';
    });
  }

  // ===== Quantity select highlight =====
  var qtySelect = document.getElementById('w-quantity');
  if (qtySelect) {
    qtySelect.addEventListener('change', function() {
      this.style.borderColor = '#D4AF37';
      setTimeout(function() {
        qtySelect.style.borderColor = '#e0e0e0';
      }, 500);
    });
  }

});
